<template>
    <div>
        <v-row class="mb-1">
            <v-col class="d-flex justify-end">
                <v-btn
                	small
                	class="mx-2 "
                	color="light-blue white--text"
                    @click="dialog = true"
                >
                    <v-icon class="me-2">
                        mdi-plus-circle-outline
                    </v-icon>
                    {{ $t('PricesTypes.add-new-price-type') }}
                </v-btn>
            </v-col>
        </v-row>
        <!-- delete dialog -->
        <delete-dialog
        	ref="deleteDialog"
            @on-delete="fetchAll"
            :success-message="$t('message.data-is-deleted')"
        >
            <template v-slot:default>
                <p class="mb-2">
                    {{$t('are-you-sure-you-want-to')}} 
                    <span class="red--text">{{$t('delete')}}</span> 
                    {{$t('PricesTypes.this-type')}} {{$t('?')}}
                </p>
            </template>
        </delete-dialog>
        <!-- dialog -->
        <v-dialog
            v-model="dialog"
            width="400"
            @keydown.esc="dialog = false"
            persistent
        >
            <v-form ref="form" @submit.prevent="submit" >
                <v-card>
                    <div class="d-flex py-1 primary">
                        <v-card-title
                            class="text-uppercase flex-grow-1 text-subtitle-1 justify-center pa-0 white--text"
                        >
                            {{ priceId ? $t('PricesTypes.edit-price-type') : $t('PricesTypes.add-new-price-type') }}
                        </v-card-title>

                        <v-btn icon @click="dialog = false">
                            <v-icon color="white"> mdi-close-circle-outline </v-icon>
                        </v-btn>
                    </div>

                    <v-card-text class="pt-2 px-3 pb-0">
                        <v-row dense class="ma-0">
                            <v-col>
                                <v-text-field 
                                    v-model="name"
                                    outlined
                                    dense
                                    hide-details
                                    :label="$t('inputs.name')"
                                    :rules="rules.required"
                                    autofocus
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            text
                            color="success"
                            :loading="submitLoading"
                            type="submit"
                        >
                            {{$t('save')}}
                        </v-btn>
                        <v-btn
                            text
                            :disabled="submitLoading"
                            @click="dialog = false"
                        >
                            {{$t('cancel')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>   
        </v-dialog>
        <bee-handy-table
            :items="pricesTypes"
            :headers="headers"
            dense
            zebra
            :items-per-page="-1"
            hide-default-footer
            :loading="loading"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <v-btn 
                        @click="priceId = item.id; 
                        dialog = true" 
                        icon 
                        color="edit-color"
                        :disabled="loading || submitLoading"
                    >
                        <v-icon> mdi-pencil </v-icon>
                    </v-btn>

                    <v-btn 
                        icon 
                        @click="$refs.deleteDialog.activeDeleteDialog(item.id, 'pricesTypes')" 
                        color="alert-color" 
                        :disabled="loading || submitLoading"
                    >
                        <v-icon> mdi-delete </v-icon>
                    </v-btn>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DeleteDialog from '@/components/DeleteDialog.vue'
import rules from '@/validation rules'
export default {
    data () {
        return {
            dialog: false,
            priceId: null,
            submitLoading: false,
            loading: false,
            name: null,
            rules
        }
    },

    components: {
        DeleteDialog
    },

    watch: {
        dialog(val) {
            if (val) {
                if (this.priceId) {
                    this.name = this.pricesTypes.find(c => c.id === this.priceId)?.name
                }
            } else {
                this.name = null
                this.priceId = null
                this.$refs.form.resetValidation()
            }
        }
    },

    computed: {
        ...mapState({
            pricesTypes: state => state.pricesTypes.pricesTypes
        }),
        headers () {
            return [
                {
                    text: this.$t('headers.name'),
                    name: 'name',
                    value: 'name'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ]
        }
    },

    methods: {
        fetchAll() {
            this.loading = true 
            this.$store.dispatch('pricesTypes/fetchAll').finally(() => {
                this.loading = false
            })
        },

        submit() {
            if (!this.$refs.form.validate()) return
            const actionName = this.priceId ? 'update' : 'create'
            this.submitLoading = true
            this.$store.dispatch(`pricesTypes/${actionName}`, { name: this.name, id: this.priceId }).then(() => {
                this.fetchAll()
                this.dialog = false
            }).finally(() => {
                this.submitLoading = false
            })
        }
    },

    created () {
        this.fetchAll()
    }
}

</script>